import { Form } from "react-bootstrap";

import Names from "./Names";
import SSN from "./SSN";

export default function PrincipalOfficerInformation({ state, onChange }) {
  return (
    <>
      <h5>Principal Officer Information</h5>
      <Names id="principalOfficer" state={state} onChange={onChange} />
      <Form.Group controlId="principalOfficerSuffixName">
        <Form.Label>Suffix Name (optional)</Form.Label>
        <Form.Control
          as="select"
          value={state && state.principalOfficerSuffixName ? state.principalOfficerSuffixName : ""}
          onChange={onChange}
        >
          <option value="">Please Select</option>
          <option value="DDS">DDS</option>
          <option value="MD">MD</option>
          <option value="PhD">PhD</option>
          <option value="JR">JR</option>
          <option value="SR">SR</option>
          <option value="I">I</option>
          <option value="II">II</option>
          <option value="III">III</option>
          <option value="IV">IV</option>
          <option value="V">V</option>
          <option value="VI">VI</option>
        </Form.Control>
      </Form.Group>
      <Form.Group controlId="principalOfficerTitle">
        <Form.Label>Title</Form.Label>
        <Form.Control
          required
          as="select"
          value={state && state.principalOfficerTitle ? state.principalOfficerTitle : ""}
          onChange={onChange}
        >
          <option value="">Please Select</option>
          <option value="ceo">CEO</option>
          <option value="executor">Executor</option>
          <option value="owner">Owner</option>
          <option value="managing member">Managing Member</option>
          <option value="managing member/owner">Managing Member/Owner</option>
          <option value="president">President</option>
          <option value="other">Other</option>
        </Form.Control>
        <Form.Control.Feedback type="invalid">Please select a valid title</Form.Control.Feedback>
      </Form.Group>
      <SSN id="principalOfficer" state={state} onChange={onChange} />
    </>
  );
}
